module.exports = __webpack_public_path__ + "img/share-instagram.a34ec7ff.png";